import { Flex, notification } from "antd";
import Search from "antd/es/input/Search";
import { FC } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getApiError, postSchedulerMoveMarketsToRoute } from "tm-shared/api";
import { RouteDetails } from "tm-shared/types";

import { BaseModal } from "@/components/BaseModal";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";
import useAsyncAction from "@/hooks/useAsyncAction";
import { useDebounce } from "@/hooks/useDebounce";
import {
    RouteEditorModal,
    RouteEditorModalPayloads,
} from "@/pages/SV/RouteManagement/RouteEditor/RouteEditor.types";

import { StyledCard } from "./Styled";

interface MoveScheduleModalProps {
    onClose: () => void;
    payload: RouteEditorModalPayloads[RouteEditorModal.MoveSchedule];
    onApprove: () => Promise<void>;
}

export const MoveScheduleModal: FC<MoveScheduleModalProps> = ({
    onClose,
    payload,
    onApprove,
}) => {
    const [search, setSearch] = useState("");

    const [selectedItem, setSelectedItem] = useState<RouteDetails | null>(null);
    const { routeList } = useAppSelector((state) => state.sv);
    const { routeId } = useParams();

    const quernRouteId = Object.values(routeList).find(
        (item) => item.agentId === routeId,
    )?.uuid;

    const debouncedSearch = useDebounce(search, 300);

    const availableRoutes = Object.values(routeList).filter((item) => {
        const normalizeSearch = debouncedSearch.toLowerCase().trim();
        const normalizeName = item.name.toLowerCase();

        return (
            item.uuid !== quernRouteId &&
            normalizeName.includes(normalizeSearch)
        );
    });

    const { currentRouteId, marketIds } = payload;

    const [handleMove, moveLoading] = useAsyncAction(async () => {
        try {
            await postSchedulerMoveMarketsToRoute({
                marketIds,
                oldRouteId: currentRouteId,
                newRouteId: selectedItem?.uuid,
            }),
                onClose();
        } catch (err) {
            console.log(err);
            const { displayMessage } = getApiError(err);
            notification.error({
                message: "Не вдалося перемістити ТТ",
                description: displayMessage,
            });
        }

        await onApprove();
    });

    return (
        <BaseModal
            open
            onClose={onClose}
            centered
            title={"Перемістити ТТ"}
            confirmText="Перемістити"
            onConfirm={handleMove}
            cancelText="Скасувати"
            onCancel={onClose}
            confirmDisabled={!selectedItem}
            confirmLoading={moveLoading}
        >
            <PrimaryText>Оберіть один маршрут для переміщення</PrimaryText>

            <Search
                allowClear
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <Flex
                vertical
                gap={8}
                style={{ overflow: "auto", minHeight: 0, height: "100%" }}
            >
                {availableRoutes.map((item) => (
                    <StyledCard
                        key={item.id}
                        $selected={selectedItem?.uuid === item.uuid}
                        onClick={() => setSelectedItem(item)}
                    >
                        <PrimaryText fontSize={16} fontWeight="500">
                            {item.name}
                        </PrimaryText>

                        <Flex gap={4}>
                            <SecondaryText fontSize={12}>
                                Кількість ТТ:
                            </SecondaryText>

                            <PrimaryText fontSize={12}>
                                {item?.marketCount ?? "-"}
                            </PrimaryText>
                        </Flex>

                        <Flex gap={4}>
                            <SecondaryText fontSize={12}>ТА:</SecondaryText>

                            <PrimaryText fontSize={12}>
                                {item?.agentFullName ?? "-"}
                            </PrimaryText>
                        </Flex>
                    </StyledCard>
                ))}
            </Flex>
        </BaseModal>
    );
};
